// extracted by mini-css-extract-plugin
export default {"title":"sessionWishlist_title__FmLE4","goBack":"sessionWishlist_goBack__+tu6H"};